import * as action from './actions/creators';
import * as api from './external-systems-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const getExternalSystems = (patientId) => (dispatch) =>
  api.getExternalSystems(patientId).then(
    (response) => {
      dispatch(action.externalSystemsLoaded(response.data));
      return response.data;
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage());
      dispatch(action.externalSystemsFailed(error.message));
    }
  );
